import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from 'components/components/common/withRouter';
import { setBookingUserData, toggleCreateAccountInBooking, setUserDataErrors } from 'components/actions/bookingActions';
import isWindow from 'components/common/helpers/isWindow';
import StepHeader from '../../common/StepHeader';
import { withStyles } from '@material-ui/core/styles';
import styles from '../../common/customStylesRadioButton';
import BookingRedirect from '../utils/BookingRedirect';
import _ from 'lodash';
import RegisterForm from './components/RegisterForm';
import LoginForm from './components/LoginForm';
import classNames from 'classnames';
import TransHelper from 'components/common/translations/TransHelper';

class UserData extends Component {

  constructor(props, context) {
    super(props, context);
  }

  state = {
    showRegister: true
  }

  componentDidMount() {
    new BookingRedirect(this.props).canViewUserData();
  }

  toggleFormState = (e) => {
    e.preventDefault();
    this.setState({ showRegister: !this.state.showRegister });
  }

  setStep = () => {
    const { childrenNumber, isLogged } = this.props;
    if (childrenNumber === 0 && !isLogged) {
      return 3;
    } else if (childrenNumber > 0 && !isLogged) {
      return 4;
    }
  }

  trans = (key) => {
    return TransHelper.translate(this.props.locale, "content.userData." + key);
  }

  render() {
    if (!isWindow) {
      return null;
    }

    return (
      <div className="content" style={{ padding: 0 }}>
        <div className="grid-layout grid-layout--vh">
          <div
            className={classNames(
              'grid-layout__item',
              'grid-layout__item--desc',
              'grid-layout__item--middle'
            )}
            style={{ overflowX: 'hidden' }}
          >
            <div className="content__desc content__desc--static">
              <StepHeader
                link="routes.url.map"
                linkTitle={this.trans('backToAddress')}
                step={this.setStep()}
                title={this.trans('personalData')}
                isAnim={true}
                booking
              />

              {this.state.showRegister
                ?
                <RegisterForm toggleFormState={this.toggleFormState} locale={this.props.locale} />
                :
                <LoginForm toggleFormState={this.toggleFormState} locale={this.props.locale} />
              }

            </div>
          </div>
          <div className="grid-layout__item grid-layout__item--info" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userData: state.booking.userData,
    childrenNumber: state.booking.childrenNumber,
    isLogged: state.app.isLogged,
    departureAddress: state.booking.departureAddress,
    returnAddress: state.booking.returnAddress,
    locale: state.app.locale
  };
};

const mapDispatchToProps = {
  setBookingUserData, toggleCreateAccountInBooking, setUserDataErrors
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)
    (withStyles(styles)(UserData))
);